// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"339":"4990551a","614":"4990551a"}[chunkId] + ".chunk.css";
};